import { TransformedCardData } from "../interface";

// Temporary workaround for Agg bug where expired status persist in 'flags' object
// `flag` is smart enough to know that `flags.status` has expired (and will prefer `flags.label`, if present)
// However, `flags.status` will continue to hold a status value, even if it's expired. This code corrects that.

export const shouldRenderStatus = (contentItem: TransformedCardData) => {
    const { flag, flags } = contentItem;

    if (!flags || !flags.status || !flag) {
        return false;
    }
    return flag !== flags.label;
};
